// extracted by mini-css-extract-plugin
export default {"ad":"index_ad_0bIpB","box":"index_box_YZKkA","footer":"index_footer_3sPFL"};